import React from "react";
import { CheckCircle } from "lucide-react";

const PlanFeatures = ({ features }) => {
  return (
    <ul className="space-y-2 text-sm text-muted-foreground">
      {features.map((feature, index) => (
        <li key={index} className="flex items-start gap-2">
          <CheckCircle className="h-4 w-4 text-green-500 flex-shrink-0 mt-0.5" />
          <span>{feature}</span>
        </li>
      ))}
    </ul>
  );
};

export default PlanFeatures;
